module.exports = __webpack_public_path__ + "img/slideshow.9f20ad8d.svg";